export default "__VITE_ASSET__CJACFCRL__"